import PdfAssetPreview from './PdfAssetPreview';

export default PdfAssetPreview;
